module.exports = __webpack_public_path__ + "static/media/Exhibition-2@2x.f1589911.png";